import Vue from 'vue'
import JwtToken from '@/services/jwt-token'
import SessionStorage from '@/services/session-storage'

const state = {
  usuario: SessionStorage.get('usuario', []),
  usuarios: [],
  usuarioEditar: [],
  usuarioVisualizar: [],
  perfilAtual: '',
  permissoes: [],
  conferencias: [],
  perfisConferencia: [],
  configuracaoAtual: {
    perfil_atual_nome: null,
    perfil_atual_id: null,
    conferencia_atual_id: null,
    conferencia_atual_sigla: null,
    conferencia_atual_nome: null,
    texto_apresentacao: null
  }
}

const getters = {
  getUsuario: state => {
    return state.usuario
  },
  getToken: state => {
    return state.usuario.token
  },
  validaPermissao: (state) => (permissao) => {
    if (state.permissoes.indexOf(permissao) > -1) {
      return true
    } else {
      return false
    }
  }
}

const mutations = {
  setUsuario (state, data) {
    state.usuario = data
  },
  setUsuarios (state, data) {
    state.usuarios = data
  },
  setUsuarioEditar (state, data) {
    state.usuarioEditar = data
  },
  setUsuarioVisualizar (state, data) {
    state.usuarioVisualizar = data
  },
  setPerfilAtual (state, data) {
    state.perfilAtual = data
  },
  setConferencias (state, data) {
    state.conferencias = data
  },  
  setPerfisConferencia (state, data) {
    state.perfisConferencia = data
  },
  atualizaPermissoes (state) {
    state.permissoes = SessionStorage.getObject('permissoes')
  },
  setConfiguracaoAtual (state, data) {
    state.configuracaoAtual = data
  },  
}

const actions = {
  configuracaoAtual (context) {
    context.commit('setConfiguracaoAtual', {
      perfil_atual_nome: SessionStorage.get('perfil_atual_nome'),
      perfil_atual_id: SessionStorage.get('perfil_atual_id'),
      conferencia_atual_id: SessionStorage.get('conferencia_atual_id'),
      conferencia_atual_nome: SessionStorage.get('conferencia_atual_nome'),
      conferencia_atual_sigla: SessionStorage.get('conferencia_atual_sigla'),
      texto_apresentacao: SessionStorage.get('texto_apresentacao')
    })
  },
  getUsuarios (context, config) {
    if (!config.page) {
      config.page = 1
    }

    if (!config.limit) {
      config.limit = 200
    }

    Vue.http.get('api/usuario?length=' + config.limit + '&page=' + config.page).then(response => {
      context.commit('setUsuarios', response.body.data.data)
    })
  },
  getUsuario (context, id) {
    Vue.http.post('api/usuario/buscar', {id: id}).then(response => {
      context.commit('setUsuario', response.data.data[0])
      context.commit('setUsuarioEditar', response.data.data[0])
      context.commit('setPerfilAtual', response.data.data[0])
    })
  },
  getConferenciasUser(context){
    Vue.http.get('api/auth/usuario/conferencia').then(response => {
      let conferencias = response.data.data[0]
      let objConferencias = []

      for (let i in conferencias) {
        objConferencias[conferencias[i].id] = { 
        'text' : conferencias[i].nome,
        'value': conferencias[i].id
        }
      }
      context.commit('setConferencias', objConferencias)
    })
  },
  getPerfisConferencia (context, perfil){
    Vue.http.get('api/auth/usuario/conferencia/perfil/ ' + perfil).then(response => {
      let perfis = response.data.data[0]
      let objPerfis = []

      for (let i in perfis) {
        objPerfis[perfis[i].id] = {
          'text' : perfis[i].nome,
          'value': perfis[i].id
        } 
      }
      console.log(objPerfis)
      context.commit('setPerfisConferencia', objPerfis)
    })
    // context.commit('setPerfisConferencia', response.data.data[0])
  },
  login (context, data) {
    return JwtToken.accessToken(data)
  },
  atualizarPermissoes (context) {
    context.commit('atualizaPermissoes')
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/usuario.js